import { render, staticRenderFns } from "./TournamentConfigurationManagement.vue?vue&type=template&id=b85e25f6&"
import script from "./TournamentConfigurationManagement.vue?vue&type=script&lang=js&"
export * from "./TournamentConfigurationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports